import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsCustomerNotificationsRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-customer-notifications',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/customer-notifications',
};
